module.exports = __webpack_public_path__ + "static/media/Cats eyes 02_SPANSKA-mixdown.dc2ce695.mp3";